
const enum AuthChallengeType {
  NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED"
}

export default AuthChallengeType;